import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg
    id="patient-view"
    width="83.919"
    height="82.809"
    viewBox="0 0 83.919 82.809"
  >
    <path
      id="Caminho_66"
      data-name="Caminho 66"
      d="M213.934,434.21a29.4,29.4,0,0,1-18.6.046,1.849,1.849,0,0,0-1.166,3.508,33.1,33.1,0,0,0,20.945-.05,1.848,1.848,0,1,0-1.179-3.5Z"
      transform="translate(-162.606 -359.787)"
      fill="#757e8d"
    />
    <path
      id="Caminho_67"
      data-name="Caminho 67"
      d="M222.332,47.2a7.594,7.594,0,1,0-7.6-7.6A7.594,7.594,0,0,0,222.332,47.2Zm0-11.492a3.9,3.9,0,1,1-3.9,3.893A3.9,3.9,0,0,1,222.332,35.707Z"
      transform="translate(-180.401 -32.01)"
      fill="#757e8d"
    />
    <path
      id="Caminho_68"
      data-name="Caminho 68"
      d="M200.788,120h-5.329A10.417,10.417,0,0,0,185,130.455v1.524a1.819,1.819,0,0,0,1.776,1.884h22.7a1.819,1.819,0,0,0,1.776-1.884v-1.524A10.417,10.417,0,0,0,200.788,120Zm-12.156,10.166a6.754,6.754,0,0,1,6.827-6.47h5.329a6.754,6.754,0,0,1,6.827,6.47Z"
      transform="translate(-156.164 -103.735)"
      fill="#757e8d"
    />
    <path
      id="Caminho_69"
      data-name="Caminho 69"
      d="M79.435,171.111a1.848,1.848,0,0,0,1.848-1.848,29.166,29.166,0,0,1,10.964-22.846,1.848,1.848,0,1,0-2.314-2.883,32.845,32.845,0,0,0-12.346,25.728,1.848,1.848,0,0,0,1.848,1.848Z"
      transform="translate(-68.606 -122.588)"
      fill="#757e8d"
    />
    <path
      id="Caminho_70"
      data-name="Caminho 70"
      d="M343.949,140.315a29.349,29.349,0,0,1,12.388,23.919,1.848,1.848,0,0,0,3.7,0,33.051,33.051,0,0,0-13.95-26.936,1.848,1.848,0,1,0-2.135,3.018Z"
      transform="translate(-285.096 -117.559)"
      fill="#757e8d"
    />
    <path
      id="Caminho_71"
      data-name="Caminho 71"
      d="M66.779,332.38a7.594,7.594,0,1,0-7.6-7.6A7.594,7.594,0,0,0,66.779,332.38Zm0-11.491a3.9,3.9,0,1,1-3.9,3.892A3.9,3.9,0,0,1,66.779,320.888Z"
      transform="translate(-53.601 -264.477)"
      fill="#757e8d"
    />
    <path
      id="Caminho_72"
      data-name="Caminho 72"
      d="M44.871,405H39.542A10.516,10.516,0,0,0,29,415.489v1.524a1.859,1.859,0,0,0,1.859,1.85h22.7a1.876,1.876,0,0,0,1.878-1.85v-1.524A10.533,10.533,0,0,0,44.871,405ZM32.715,415.166a6.754,6.754,0,0,1,6.827-6.47h5.329a6.754,6.754,0,0,1,6.827,6.47Z"
      transform="translate(-29 -336.055)"
      fill="#757e8d"
    />
    <path
      id="Caminho_73"
      data-name="Caminho 73"
      d="M370.287,324.781a7.6,7.6,0,1,0,7.6-7.589A7.6,7.6,0,0,0,370.287,324.781Zm11.5,0a3.9,3.9,0,1,1-3.9-3.892A3.9,3.9,0,0,1,381.788,324.781Z"
      transform="translate(-307.202 -264.478)"
      fill="#757e8d"
    />
    <path
      id="Caminho_74"
      data-name="Caminho 74"
      d="M355.891,405h-5.329A10.533,10.533,0,0,0,340,415.489v1.524a1.876,1.876,0,0,0,1.878,1.85h22.7a1.859,1.859,0,0,0,1.859-1.85v-1.524A10.516,10.516,0,0,0,355.891,405Zm-12.157,10.167a6.753,6.753,0,0,1,6.827-6.47h5.329a6.754,6.754,0,0,1,6.827,6.47Z"
      transform="translate(-282.514 -336.055)"
      fill="#757e8d"
    />
  </svg>,
  'PatientViewIcon',
);
